import {
  CdkDragDrop,
  CdkDragEnter,
  moveItemInArray
} from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ConfirmationService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import {
  CodeType,
  codeTypes,
  editorTypes,
  GetQUestionParamsInQuestionBank,
  MultiData,
  options,
  PanelType,
  panelTypes,
  TikZType,
  Video
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { questionCategories } from '../create-question/create-question.constant';
import { HttpEventType } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { info } from 'console';
import { SanitizeService } from 'src/app/services/sanitize.service';

interface Panel {
  title: string;
  content: MultiData[];
  panelType: PanelType;
  hidden: boolean;
  questions:
    | any[]
    | { question: MultiData[]; answer: MultiData; hidden?: boolean }[];
  tempQuestions?: number[];
  subTitle: string;
  additionalInfo?: MultiData[];
}

declare var update: any;

@Component({
  selector: 'app-create-module',
  templateUrl: './create-module.component.html',
  styleUrls: ['./create-module.component.scss']
})
export class CreateModuleComponent implements OnInit {
  editorArray: Panel[] = [];

  showTextArea: boolean = true;

  codeTypes: CodeType[] = codeTypes;

  selectedPanel: number | null = null;

  overlayType: string = '';
  panelTypes: PanelType[] = panelTypes;
  deleteInfo: {
    index: number;
    type: string;
    selectedPanel: number;
    questionIndex?: number;
  } | null = null;

  showPanelItems: boolean = true;
  showCoursesFilterItems: boolean = true;

  tempSelectedQuestionId: any[] = [];
  selectedQuestionId: any[] = [];

  selectedCourse: number = 0;
  selectedSection: number = 0;
  selectedTopic: number = 0;
  selectedSubTopic: number = 0;
  selectedQuestionLevel: number = 0;
  courses: any[] = [];
  sections: any[] = [];
  topics: any[] = [];
  subTopics: any[] = [];

  showDialog: boolean = false;

  questions: any[] = [];
  optionsText: string[] = options;
  selectedQuestionIndex: number = -1;
  selectedManualQuestionIndex: number = -1;

  dialogSelectedCourse: number = 0;
  dialogSelectedSection: number = 0;
  dialogSelectedTopic: number = 0;
  dialogSelectedSubTopic: number = 0;
  dialogSections: any[] = [];
  dialogTopics: any[] = [];
  dialogSubTopics: any[] = [];
  saveClicked: boolean = false;
  error: boolean = false;
  notifier: NotifierService;
  status: number = 1;
  moduleId: string | null = null;
  images: any = {};
  questionCategories = questionCategories;
  selectedQuestionCategory: number = 0;
  loading: boolean = false;
  videoMap: Map<number, any> = new Map<number, any>();
  questionVideoMap: Map<number, any> = new Map<number, any>();

  panelStrings = {
    CODE: 'code',
    ADDITIONAL: 'additional',
    QUESTION: 'question',
    PANEL: 'panel'
  };

  editorTypes = editorTypes;

  constructor(
    private globalApiService: GlobalApiService,
    private confirmationService: ConfirmationService,
    notifierService: NotifierService,
    private sanitizeService: SanitizeService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.getTestTypes();
    this.codeTypes = this.codeTypes.filter(
      (codeType) => codeType.type !== 'Empty'
    );
  }

  toggleCoursesFilterItems() {
    this.showCoursesFilterItems = !this.showCoursesFilterItems;
  }

  togglePanelItems() {
    this.showPanelItems = !this.showPanelItems;
  }

  toggleTextArea() {
    this.showTextArea = !this.showTextArea;
  }

  addPanel(panelType: PanelType, overlay: OverlayPanel) {
    this.editorArray.push({
      title: panelType.display.includes('Exercise')
        ? 'Exercise'
        : panelType.display,
      content: [],
      panelType,
      hidden: false,
      questions: [],
      subTitle: '',
      additionalInfo: []
    });
    this.editorArray.forEach((item: Panel, index: number) => {
      item.hidden = index !== this.editorArray.length - 1;
    });
    overlay.hide();
    console.log('Previous array: ', this.editorArray);
  }

  removePanel() {
    switch (this.deleteInfo!.type) {
      case 'code':
        this.editorArray[this.deleteInfo!.selectedPanel].content.splice(
          this.deleteInfo!.index,
          1
        );
        break;
      case 'panel':
        this.editorArray.splice(this.deleteInfo!.index, 1);
        break;
      case 'question':
        this.editorArray[this.deleteInfo!.selectedPanel].questions?.splice(
          this.deleteInfo!.index,
          1
        );
        break;
      case 'code-question':
        this.editorArray[this.deleteInfo!.selectedPanel].questions![
          this.deleteInfo!.questionIndex!
        ].question.splice(this.deleteInfo!.index, 1);
        break;
      case 'additional':
        this.editorArray[this.deleteInfo!.selectedPanel].additionalInfo?.splice(
          this.deleteInfo!.index,
          1
        );
        break;
    }
    this.deleteInfo = null;
  }

  addPanelContent(type: string, overlay: OverlayPanel) {
    console.log(this.selectedPanel, this.selectedManualQuestionIndex);
    if (this.overlayType === 'code') {
      this.editorArray[this.selectedPanel!].content = this.editorArray[
        this.selectedPanel!
      ].content.filter((content) => content.type !== 'Empty');
      this.editorArray[this.selectedPanel!].content.push({
        data: '',
        type: type,
        hidden: false,
        images: [],
        selectedVideos: [],
        isUploading: false,
        uploadProgress: 0,
        videos: []
      });
      overlay.hide();
      this.editorArray[this.selectedPanel!].content.forEach(
        (item: any, index: number) => {
          item.hidden =
            index !== this.editorArray[this.selectedPanel!].content.length - 1;
        }
      );
    } else if (this.overlayType === this.panelStrings.ADDITIONAL) {
      this.editorArray[this.selectedPanel!].additionalInfo?.push({
        data: '',
        type: type,
        hidden: false,
        images: [],
        selectedVideos: [],
        isUploading: false,
        uploadProgress: 0,
        videos: []
      });
      overlay.hide();
      this.editorArray[this.selectedPanel!].additionalInfo?.forEach(
        (item: any, index: number) => {
          item.hidden =
            index !==
            this.editorArray[this.selectedPanel!].additionalInfo!.length - 1;
        }
      );
    } else {
      this.editorArray[this.selectedPanel!].questions![
        this.selectedManualQuestionIndex
      ].question.push({
        data: '',
        type: type,
        hidden: false,
        images: [],
        selectedVideos: [],
        isUploading: false,
        uploadProgress: 0,
        videos: []
      });
      overlay.hide();
      this.editorArray[this.selectedPanel!].questions![
        this.selectedManualQuestionIndex
      ].question.forEach((item: any, index: number) => {
        item.hidden =
          index !==
          this.editorArray[this.selectedPanel!].questions![
            this.selectedManualQuestionIndex
          ].question.length -
            1;
      });
    }
  }

  toggleAccordion(toggleIndex: number, array: any[]) {
    console.log(toggleIndex, array);
    array.forEach((item, index) => {
      if (index === toggleIndex) {
        item.hidden = !item.hidden;
      } else {
        item.hidden = true;
      }
    });
  }

  toggleOverlay(
    overlayPanel: OverlayPanel,
    event: any,
    index: number,
    type: string,
    panelType: string,
    questionIndex?: number
  ) {
    if (type === 'code') {
      if (
        panelType === 'Exercise (From Question Bank)' ||
        panelType === 'Quiz'
      ) {
        this.dialogSelectedCourse = this.selectedCourse;
        this.dialogSelectedSection = this.selectedSection;
        this.dialogSelectedTopic = this.selectedTopic;
        this.dialogSelectedSubTopic = this.selectedSubTopic;

        this.dialogSections = this.sections;
        this.dialogTopics = this.topics;
        this.dialogSubTopics = this.subTopics;
        this.showDialog = true;
        this.selectedQuestionIndex = index;
      } else if (panelType === 'Exercise (Enter Manually)') {
        this.editorArray[index].questions?.push({
          question: [
            { type: 'MathJax', data: '', hidden: false, images: [], videos: [] }
          ],
          answer: { type: 'MathJax', data: '', hidden: false, images: [] },
          hidden: false
        });
        this.editorArray[index].questions?.forEach(
          (question, questionIndex) => {
            question.hidden =
              questionIndex !== this.editorArray[index].questions!.length - 1;
          }
        );
      } else {
        overlayPanel.toggle(event);
        this.selectedPanel = index;
        this.overlayType = type;
      }
    } else {
      overlayPanel.toggle(event);
      this.selectedPanel = index;
      this.overlayType = type;
      this.selectedManualQuestionIndex =
        questionIndex || questionIndex === 0 ? questionIndex : -1;
    }
  }

  confirmDelete(
    index: number,
    type: string,
    selectedPanel: number,
    questionIndex?: number
  ) {
    console.log('clicked');
    this.deleteInfo = { index, type, selectedPanel, questionIndex };
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Question?',
      header: 'Confirmation',
      accept: () => {
        this.removePanel();
      },
      reject: () => {
        this.deleteInfo = null;
      }
    });
  }

  getTestTypes() {
    this.globalApiService.getTestTypes().subscribe(
      (response: any) => {
        console.log(response);
        this.courses = response;
        console.log(this.courses);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  /* On Course Selection */
  selectCourse(dialog?: string): void {
    if (dialog) {
      this.dialogSelectedSection = 0;
      this.dialogSelectedTopic = 0;
      this.dialogSelectedSubTopic = 0;
      this.dialogSections = [];
      this.dialogTopics = [];
      this.dialogSubTopics = [];
    } else {
      this.selectedSection = 0;
      this.selectedTopic = 0;
      this.selectedSubTopic = 0;
      this.sections = [];
      this.topics = [];
      this.subTopics = [];
      this.selectedQuestionCategory = 0;
      this.selectedQuestionLevel = 0;
    }
    this.getSectionsForCourse(dialog);
  }

  /* On Section Selection */
  selectSection(dialog?: string): void {
    if (dialog) {
      this.dialogSelectedTopic = 0;
      this.dialogSelectedSubTopic = 0;
      this.dialogTopics = [];
      this.dialogSubTopics = [];
    } else {
      this.selectedTopic = 0;
      this.selectedSubTopic = 0;
      this.topics = [];
      this.subTopics = [];
    }
    this.getTopicsAndSubTopics(dialog);
  }

  /* On topic selection */
  selectTopic(dialog?: string) {
    if (dialog) {
      this.dialogSelectedSubTopic = 0;
      const topicIndex = this.dialogTopics.findIndex((topic: any) => {
        return topic.topic_id === this.dialogSelectedTopic;
      });
      console.log(topicIndex);
      this.dialogSubTopics = this.dialogTopics[topicIndex].subtopics;
    } else {
      this.selectedSubTopic = 0;
      const topicIndex = this.topics.findIndex((topic: any) => {
        return topic.topic_id === this.selectedTopic;
      });
      console.log(topicIndex);
      this.subTopics = this.topics[topicIndex].subtopics;
    }
  }

  selectSubTopic() {
    this.loading = true;
    this.getLearningModule();
  }

  getSectionsForCourse(dialog?: string) {
    this.globalApiService
      .getSectionsByTestTypeId(
        dialog ? this.dialogSelectedCourse : this.selectedCourse
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          const data = JSON.parse(response.data);
          console.log(data);
          const sections = data || [];
          if (dialog) {
            this.dialogSections = sections;
          } else {
            this.sections = sections;
          }
        },
        (error: any) => {
          // this.notifier.notify('error', 'Unable to fetch section types');
        }
      );
  }

  getTopicsAndSubTopics(dialog?: string): void {
    let sectionIndex: number = -1;
    if (dialog) {
      sectionIndex = this.dialogSections.findIndex((section) => {
        return this.dialogSelectedSection === section.test_section_type_id;
      });
    } else {
      sectionIndex = this.sections.findIndex((section) => {
        return this.selectedSection === section.test_section_type_id;
      });
    }
    this.globalApiService
      .getTopicsAndSubTopicsByTestSection(
        dialog
          ? this.dialogSections[sectionIndex].test_section_type_id
          : this.sections[sectionIndex].test_section_type_id
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          const data: any = JSON.parse(response.data);
          if (dialog) {
            this.dialogTopics = data.result;
          } else {
            this.topics = data.result;
          }
        },
        (error: any) => {
          console.log(error);
          this.notifier.notify('error', 'Unable to fetch topics and subtopics');
        }
      );
  }

  getQuestionsWithParams() {
    if (this.selectedSubTopic !== null) {
      this.loading = true;
      console.log('Loading get questions');
      const params: GetQUestionParamsInQuestionBank = {
        topicId: this.dialogSelectedTopic,
        subTopicId: this.dialogSelectedSubTopic,
        difficultyLevel: this.selectedQuestionLevel || 0,
        questionType: 0,
        pageNo: 1,
        tags: '',
        questionCategories: this.selectedQuestionCategory
      };
      this.globalApiService
        .getQuestionsWithParamsInQuestionBank(params)
        .subscribe(
          (response: any) => {
            console.log(response);
            // this.questions = response.questions || [];
            this.questions = response.questions.map((question: any) => {
              return { ...question, selected: false };
            });
            this.loadImages();
            this.loadTikZ();
            this.loading = false;
          },
          (error: any) => {
            console.log(error);
            // this.notifier.notify('error', 'Unable to load Questions');
            this.loading = false;
          }
        );
    }
  }

  loadImages() {
    const listOfImages: string[] = [];
    this.questions.forEach((questionItem: any) => {
      const questionData = questionItem.question.questionData;
      questionData.forEach((question: any, questionIndex: number) => {
        if (question['type'] === 'Images') {
          question['images'] = JSON.parse(question['data']) || [];
          listOfImages.push(...question['images']);
        }
      });
      if (questionItem.question.questionType === 1) {
        questionItem.choices.forEach((choice: any, index: number) => {
          const optionValue: any[] = choice.optionValue || [];
          optionValue.forEach((option, optionIndex) => {
            if (option['type'] === 'Images') {
              option['images'] = JSON.parse(option['data']) || [];
              listOfImages.push(...option['images']);
            }
          });
          const explanations: any[] = choice.explanation || [];
          explanations.forEach((explanation, explanationIndex) => {
            if (explanation['type'] === 'Images') {
              explanation['images'] = JSON.parse(explanation['data']) || [];
              listOfImages.push(...explanation['images']);
            }
          });
        });
      } else if (questionItem.question.questionType === 2) {
        questionItem.answers.explanation.forEach(
          (explanation: any, explanationIndex: number) => {
            if (explanation['type'] === 'Images') {
              explanation['images'] = JSON.parse(explanation['data']) || [];
              listOfImages.push(...explanation['images']);
            }
          }
        );
      }
    });
    this.getImages(listOfImages);
  }

  loadTikZ() {
    const totaltikZ: TikZType[] = [];
    this.questions.forEach((qData: any, qIndex: number) => {
      const questions = qData.question.questionData;
      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        if (question.type === 'TikZ') {
          totaltikZ.push({
            id: 'tikzOutput-' + qIndex + '-' + i,
            data: question.data
          });
        }
      }
      console.log(totaltikZ);
      if (qData.question.questionType === 1) {
        const options = qData.choices;
        for (let i = 0; i < options.length; i++) {
          const option = options[i];
          for (let j = 0; j < option.optionValue.length; j++) {
            const optionItem = option.optionValue[j];
            if (optionItem.type === 'TikZ') {
              totaltikZ.push({
                id: 'tikzOutput-option-' + qIndex + '-' + i + '-' + j,
                data: optionItem.data
              });
            }
          }
        }
      }
    });
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  previewLoadTikZ() {
    const totaltikZ: TikZType[] = [];
    this.editorArray.forEach((panel: Panel, panelIndex: number) => {
      if (
        panel.panelType.display.includes('Exercise') ||
        panel.panelType.type === 'quiz'
      ) {
        if (panel.panelType.display.includes('Manual')) {
          panel.questions?.forEach((question: any, questionIndex: number) => {
            question.question.forEach((item: any, itemIndex: number) => {
              if (item.type === 'TikZ') {
                totaltikZ.push({
                  id: `learningModule-tikz-${itemIndex}-${questionIndex}-${panelIndex}`,
                  data: item.data
                });
              }
            });
          });
        } else {
          panel.questions?.forEach((question: any, questionIndex: number) => {
            const questionData = question.question.questionData;
            questionData.forEach((item: any, itemIndex: number) => {
              if (item.type === 'TikZ') {
                totaltikZ.push({
                  id: `learningModule-tikz-${itemIndex}-${questionIndex}-${panelIndex}`,
                  data: item.data
                });
              }
            });
            const questionType = question.question.questionType;
            if (questionType === 1) {
              const options = question.choices;
              options.forEach((option: any, optionIndex: number) => {
                option.optionValue.forEach(
                  (optionValue: any, optionValueIndex: number) => {
                    if (optionValue.type === 'TikZ') {
                      totaltikZ.push({
                        id: `learningModule-tikz-${optionValueIndex}-${optionIndex}-${questionIndex}-${panelIndex}`,
                        data: optionValue.data
                      });
                    }
                  }
                );
                if (option.isAnswer) {
                  option.optionValue.forEach(
                    (optionValue: any, optionValueIndex: number) => {
                      if (optionValue.type === 'TikZ') {
                        totaltikZ.push({
                          id: `learningModule-tikz-answer-${optionValueIndex}-${optionIndex}-${questionIndex}-${panelIndex}`,
                          data: optionValue.data
                        });
                      }
                    }
                  );
                }
                option.explanation?.forEach(
                  (explanation: any, explanationIndex: number) => {
                    if (explanation.type === 'TikZ') {
                      totaltikZ.push({
                        id: `learningModule-tikz-explanation-${explanationIndex}-${optionIndex}-${questionIndex}-${panelIndex}`,
                        data: explanation.data
                      });
                    }
                  }
                );
              });
            } else {
              const explanations = question.answers.explanation || [];
              explanations.forEach(
                (explanation: any, explanationIndex: number) => {
                  if (explanation.type === 'TikZ') {
                    totaltikZ.push({
                      id: `learningModule-tikz-explanation-${explanationIndex}-${questionIndex}-${panelIndex}`,
                      data: explanation.data
                    });
                  }
                }
              );
            }
          });
        }
        if (panel.additionalInfo) {
          panel.additionalInfo.forEach((info: MultiData, infoIndex: number) => {
            if (info.type === 'TikZ') {
              totaltikZ.push({
                id: `learningModule-tikz-additional-${infoIndex}-${panelIndex}`,
                data: info.data
              });
            }
          });
        }
      } else {
        panel.content.forEach((content: MultiData, contentIndex: number) => {
          if (content.type === 'TikZ') {
            totaltikZ.push({
              id: `learningModule-tikz-${contentIndex}-${panelIndex}`,
              data: content.data
            });
          }
        });
      }
    });
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
    }, 500);
  }

  checkBoxEvent(event: any, questionId: number) {
    if (event.checked == true) {
      this.tempSelectedQuestionId.push(questionId);
    }
    if (event.checked == false) {
      const index = this.tempSelectedQuestionId.indexOf(questionId);
      if (index > -1) {
        this.tempSelectedQuestionId.splice(index, 1);
      }
    }
    console.log('tempSelectedQuestionId is: ', this.tempSelectedQuestionId);
  }

  addSelectedQuestionId() {
    console.log(this.questions);
    let existingQuestionIds: any[] = [];
    this.editorArray.forEach((panel: Panel) => {
      if (panel.panelType.type === 'quiz' || panel.panelType.type === 'qb') {
        panel.questions.forEach((question: any) => {
          existingQuestionIds.push(question.question.questionId);
        });
      }
    });
    console.log(existingQuestionIds);
    const newQuestions = this.questions.filter((question) => {
      return (
        question.selected &&
        existingQuestionIds.indexOf(question.question.questionId) < 0
      );
    });
    console.log(newQuestions);
    newQuestions.forEach((question: any) => {
      const videos: Video[] = [];
      question.videos?.forEach((video: any) => {
        videos.push({
          videoId: video.videoId,
          isActive: false
        });
        video.safeBunnyUrl = this.sanitizeService.getBunnyVideoUrl(video);
        this.questionVideoMap.set(video.videoId, video);
      });
      question.videos = videos;
    });
    this.editorArray[this.selectedQuestionIndex].questions =
      this.editorArray[this.selectedQuestionIndex].questions!.concat(
        newQuestions
      );
    this.dialogSelectedCourse = 0;
    this.dialogSelectedSection = 0;
    this.dialogSelectedTopic = 0;
    this.dialogSelectedSubTopic = 0;

    this.questions = [];
    this.showDialog = false;
    console.log(this.editorArray);
  }

  removeQuestion(index: number, questionIndex: number) {
    this.editorArray[index].questions?.splice(questionIndex, 1);
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.editorArray, event.previousIndex, event.currentIndex);
  }

  dropQuestion(event: CdkDragEnter<any>, questionArray: any[]) {
    moveItemInArray(questionArray, event.item.data, event.container.data);
  }

  saveLearningModule() {
    if (!this.saveClicked) {
      this.saveClicked = true;
      let error = false;
      if (this.editorArray.length === 0) {
        error = true;
      }
      if (!error) {
        for (let i = 0; i < this.editorArray.length; i++) {
          const panel: Panel = this.editorArray[i];
          if (panel.title === '' && panel.panelType.display !== 'General') {
            error = true;
            break;
          } else {
            if (
              panel.panelType.display.includes('Exercise') ||
              panel.panelType.type === 'quiz'
            ) {
              if (panel.questions?.length === 0) {
                error = true;
                break;
              } else if (panel.panelType.display.includes('Manual')) {
                for (let j = 0; j < panel.questions!.length; j++) {
                  const question = panel.questions![j];
                  if (question.answer.data === '') {
                    error = true;
                    break;
                  } else {
                    if (question.question.length === 0) {
                      error = true;
                      break;
                    }
                    for (let k = 0; k < question.question.length; k++) {
                      const questionItem = question.question[k];
                      if (
                        questionItem.data === '' &&
                        questionItem.type !== 'Images' &&
                        questionItem.type !== 'Videos'
                      ) {
                        error = true;
                        break;
                      } else if (
                        questionItem.type === 'Images' &&
                        questionItem.images.length === 0
                      ) {
                        error = true;
                        break;
                      } else if (
                        questionItem.type === 'Videos' &&
                        questionItem.videos?.length === 0
                      ) {
                        error = true;
                        break;
                      }
                    }
                    if (error) break;
                  }
                }
                if (error) break;
              }
            } else {
              if (panel.panelType.type === 'overview') {
                if (panel.content.length === 0) {
                  const data: MultiData = {
                    type: 'Empty',
                    data: '',
                    images: []
                  };
                  panel.content.push(data);
                }
              }
              if (panel.panelType.type !== 'tip') {
                if (panel.content.length === 0) {
                  error = true;
                  break;
                }
              }
              if (!error) {
                for (let j = 0; j < panel.content.length; j++) {
                  const content: MultiData = panel.content[j];
                  if (panel.panelType.type !== 'overview') {
                    if (panel.panelType.type !== 'tip') {
                      if (
                        content.data === '' &&
                        content.type !== 'Images' &&
                        content.type !== 'Videos'
                      ) {
                        error = true;
                        break;
                      } else if (
                        content.type === 'Images' &&
                        content.images.length === 0
                      ) {
                        error = true;
                        break;
                      } else if (
                        content.type === 'Videos' &&
                        content.videos?.length === 0
                      ) {
                        error = true;
                        break;
                      }
                    }
                  }
                }
                if (error) break;
              }
            }
            if (
              (panel.panelType.display.includes('Exercise') ||
                panel.panelType.type === 'quiz') &&
              !error
            ) {
              const additionalInfo = panel.additionalInfo || [];
              for (let j = 0; j < additionalInfo.length; j++) {
                const content: MultiData = additionalInfo[j];
                if (
                  content.data === '' &&
                  content.type !== 'Images' &&
                  content.type !== 'Videos'
                ) {
                  error = true;
                  break;
                } else if (
                  content.type === 'Images' &&
                  content.images.length === 0
                ) {
                  error = true;
                  break;
                } else if (
                  content.type === 'Videos' &&
                  content.videos?.length === 0
                ) {
                  error = true;
                  break;
                }
              }
              if (error) break;
            }
          }
        }
      }
      if (!error) {
        if (this.selectedCourse === 0) {
          error = true;
        } else if (this.selectedSection === 0) {
          error = true;
        } else if (this.selectedTopic === 0) {
          error = true;
        } else if (this.selectedSubTopic === 0) {
          error = true;
        }
      }
      this.error = error;
      if (!error) {
        const moduleData: any = {
          module: {
            moduleTab: [],
            status: this.status
          },
          moduleCourseType: [
            {
              courseTypeId: this.selectedCourse,
              sectionId: this.selectedSection,
              subTopicId: this.selectedSubTopic,
              topicId: this.selectedTopic
            }
          ]
        };
        const moduleTab: any[] = [];
        let quizQuestionCount = 0;
        let exerciseQuestionCount = 0;
        this.editorArray.forEach((panel: Panel) => {
          let content: any[] = [];
          if (
            panel.panelType.display.includes('Exercise') ||
            panel.panelType.type === 'quiz'
          ) {
            if (panel.panelType.display.includes('Manual')) {
              content = panel.questions!.map((question) => {
                return {
                  type: 'static_question',
                  data: JSON.stringify({
                    question: question.question,
                    answer: question.answer
                  })
                };
              });
            } else {
              content = panel.questions!.map((question) => {
                return {
                  type: 'question',
                  data: question.question.questionId
                };
              });
              if (panel.panelType.type === 'quiz') {
                quizQuestionCount += content.length;
              } else {
                exerciseQuestionCount += content.length;
              }
            }
            let additionalInfo: any[] = panel.additionalInfo || [];
            additionalInfo = additionalInfo.map((infoItem) => {
              return {
                type: infoItem.type,
                data:
                  infoItem.type === 'Images'
                    ? JSON.stringify(infoItem.images)
                    : infoItem.type === 'Videos'
                      ? JSON.stringify(
                          infoItem.videos?.map((video: Video) => video.videoId)
                        )
                      : infoItem.data
              };
            });
            content = additionalInfo.concat(content);
          } else {
            content = panel.content.map((content) => {
              return {
                type: content.type,
                data:
                  content.type === 'Images'
                    ? JSON.stringify(content.images)
                    : content.type === 'Videos'
                      ? JSON.stringify(
                          content.videos?.map((video: Video) => video.videoId)
                        )
                      : content.data
              };
            });
            if (panel.panelType.type === 'tip' && panel.subTitle !== '') {
              content = [{ type: 'subtitle', data: panel.subTitle }].concat(
                content
              );
            }
          }
          moduleTab.push({
            title: panel.title,
            type: panel.panelType.type,
            content
          });
        });
        console.log(moduleTab, quizQuestionCount, exerciseQuestionCount);
        moduleData.module.moduleTab = moduleTab;
        moduleData.module.excersizeQuestionCount = exerciseQuestionCount;
        moduleData.module.quizQuestioinCount = quizQuestionCount;
        console.log(moduleData);
        if (this.moduleId) {
          this.globalApiService
            .updateLearningModule(this.moduleId, moduleData)
            .subscribe(
              (response: any) => {
                console.log(response);
                this.saveClicked = false;
                this.notifier.notify(
                  'success',
                  'Successfully saved Learning Module'
                );
                this.getLearningModule();
              },
              (error: any) => {
                console.log(error);
                this.notifier.notify('error', 'Unable to save learning module');
                this.saveClicked = false;
              }
            );
        } else {
          this.globalApiService.saveLearningModule(moduleData).subscribe(
            (response: any) => {
              console.log(response);
              this.saveClicked = false;
              this.moduleId = response.data || '';
              this.notifier.notify(
                'success',
                'Successfully saved Learning Module'
              );
              this.getLearningModule();
            },
            (error: any) => {
              console.log(error);
              this.notifier.notify('error', 'Unable to save learning module');
              this.saveClicked = false;
            }
          );
        }
      } else {
        this.notifier.notify('error', 'Clear all errors');
        this.saveClicked = false;
      }
    }
  }

  getLearningModule() {
    this.globalApiService
      .getLearningModule(
        this.selectedCourse,
        this.selectedSection,
        this.selectedTopic,
        this.selectedSubTopic
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          if (response.length > 0) {
            const moduleData: any = response[0];
            this.moduleId = moduleData.module.moduleId;
            if (this.moduleId) this.getLearninModuleVideos();
            this.status = moduleData.module.status;
            const editorArray: Panel[] = [];
            if (moduleData.module.moduleTab) {
              console.log(moduleData.module.moduleTab);
              let hiddenModule = false;
              moduleData.module.moduleTab.forEach(
                (module: any, index: number) => {
                  const panelType: PanelType | undefined = this.panelTypes.find(
                    (panel: PanelType) => {
                      return panel.type === module.type;
                    }
                  );
                  console.log(panelType);
                  if (panelType !== undefined) {
                    if (
                      panelType.display.includes('Exercise') ||
                      panelType.type === 'quiz'
                    ) {
                      const additionalInfo: MultiData[] = [];
                      const questions: any[] = [];
                      module.content.forEach((content: any) => {
                        if (
                          content.type !== 'static_question' &&
                          content.type !== 'question'
                        ) {
                          additionalInfo.push({
                            ...content,
                            hidden: additionalInfo.length !== 0,
                            images:
                              content.type === 'Images'
                                ? JSON.parse(content.data)
                                : [],
                            videos:
                              content.type === 'Videos'
                                ? JSON.parse(content.data)?.map(
                                    (videoId: number) => {
                                      return {
                                        videoId,
                                        isActive: false,
                                        isEditorActive: false
                                      };
                                    }
                                  )
                                : [],
                            isUploading: false,
                            uploadProgress: 0,
                            selectedVideos: []
                          });
                        } else {
                          questions.push(content);
                        }
                      });
                      if (panelType.type === 'manual') {
                        editorArray.push({
                          title: module.title,
                          content: [],
                          panelType,
                          hidden: hiddenModule,
                          questions: questions.map(
                            (content: any, contentIndex: number) => {
                              const data = JSON.parse(content.data);
                              console.log('manual parsed question data', data);
                              return {
                                question: data.question.map(
                                  (question: any, questionIndex: number) => {
                                    question.videos?.forEach((video: Video) => {
                                      video.isActive = false;
                                      video.isEditorActive = false;
                                    });
                                    return {
                                      ...question,
                                      hidden: questionIndex !== 0
                                    };
                                  }
                                ),
                                answer: { ...data.answer, hidden: false },
                                hidden: contentIndex !== 0
                              };
                            }
                          ),
                          subTitle: '',
                          additionalInfo
                        });
                      } else {
                        editorArray.push({
                          title: module.title,
                          content: [],
                          panelType,
                          hidden: hiddenModule,
                          questions: [],
                          tempQuestions: questions.map((content: any) => {
                            return parseInt(content.data) || 0;
                          }),
                          subTitle: '',
                          additionalInfo
                        });
                      }
                    } else {
                      console.log('------------- in else');
                      let subTitle = '';
                      let content = [];
                      content = module.content.map(
                        (content: any, contentIndex: number) => {
                          return {
                            ...content,
                            // ** Hiding the accordion if 'empty' type is pushed (i.e if there is no content)
                            hidden:
                              contentIndex !== 0 && content.type !== 'Empty',
                            images:
                              content.type === 'Images'
                                ? JSON.parse(content.data)
                                : [],
                            videos:
                              content.type === 'Videos'
                                ? JSON.parse(content.data).map(
                                    (videoId: number) => {
                                      return {
                                        videoId,
                                        isActive: false,
                                        isEditorActive: false
                                      };
                                    }
                                  )
                                : [],
                            isUploading: false,
                            uploadProgress: 0,
                            selectedVideos: []
                          };
                        }
                      );
                      // TODO: Wait for it
                      if (panelType.type === 'tip') {
                        content = module.content.filter((content: any) => {
                          if (content.type === 'subtitle') {
                            subTitle = content.data;
                          }
                          if (content.type === 'Images') {
                            content['images'] = JSON.parse(content.data);
                          }
                          if (content.type === 'Videos') {
                            content['videos'] = JSON.parse(content.data).map(
                              (videoId: number) => {
                                return {
                                  videoId,
                                  isActive: false,
                                  isEditorActive: false
                                };
                              }
                            );
                            content.isUploading = false;
                            content.uploadProgress = 0;
                            content.selectedVideos = [];
                          }
                          return content.type !== 'subtitle';
                        });
                      }
                      editorArray.push({
                        title: module.title,
                        content,
                        panelType,
                        hidden: hiddenModule,
                        questions: [],
                        subTitle
                      });
                    }
                    hiddenModule = true;
                    console.log(editorArray);
                  }
                }
              );
            }
            this.editorArray = editorArray;
            console.log(
              'constructed editor array from get learning module',
              structuredClone(this.editorArray)
            );
            const listOfImages: string[] = [];
            this.editorArray.forEach((panel: Panel, index: number) => {
              if (
                panel.panelType.type === 'quiz' ||
                panel.panelType.type === 'qb'
              ) {
                const questions = panel.tempQuestions || [];
                questions.forEach((question: number, questionIndex: number) => {
                  this.getQuestion(question, index, questionIndex);
                });
                const additionalInfo = panel.additionalInfo || [];
                additionalInfo.forEach((panelContent) => {
                  if (panelContent.type === 'Images') {
                    const images = panelContent.images;
                    images?.forEach((image) => {
                      listOfImages.push(image);
                    });
                  }
                });
              } else if (panel.panelType.type === 'manual') {
                const questions = panel.questions;
                questions.forEach((question) => {
                  question.question.forEach((questionItem: MultiData) => {
                    if (questionItem.type === 'Images') {
                      const images = questionItem.images;
                      images?.forEach((image) => {
                        listOfImages.push(image);
                      });
                    }
                  });
                });
                const additionalInfo = panel.additionalInfo || [];
                additionalInfo.forEach((panelContent) => {
                  if (panelContent.type === 'Images') {
                    const images = panelContent.images;
                    images?.forEach((image) => {
                      listOfImages.push(image);
                    });
                  }
                });
              } else {
                console.log('in tip else');
                const content = panel.content;
                content.forEach((panelContent) => {
                  if (panelContent.type === 'Images') {
                    const images = panelContent.images;
                    console.log(images);
                    images?.forEach((image) => {
                      console.log(image);
                      listOfImages.push(image);
                    });
                  }
                });
              }
            });
            if (listOfImages.length > 0) {
              console.log(listOfImages);
              this.getImages(listOfImages);
            }
            console.log(this.editorArray);
          } else {
            this.moduleId = null;
            this.status = 1;
            this.editorArray = [];
          }
          this.loading = false;
        },
        (error: any) => {
          console.log('error');
          this.notifier.notify('error', 'Unable to fetch learning module');
          this.loading = false;
        }
      );
  }

  getQuestion(questionId: number, index: number, questionIndex: number) {
    this.globalApiService.getQuestions(questionId).subscribe(
      (response: any) => {
        console.log(response);
        if (response) {
          this.editorArray[index].questions[questionIndex] = response;
          const listOfImages: string[] = [];
          const questionData = response.question.questionData;
          const videos: any[] = [];
          if (response.videos?.length > 0) {
            response.videos.forEach((video: any) => {
              video.safeBunnyUrl = this.sanitizeService.getBunnyVideoUrl(video);
              this.questionVideoMap.set(video.videoId, video);
              videos.push({
                videoId: video.videoId,
                isActive: false
              });
            });
          }
          console.log('constructed question videos', videos);
          this.editorArray[index].questions[questionIndex].videos = videos;

          questionData.forEach((question: any, questionIndex: number) => {
            if (question['type'] === 'Images') {
              question['images'] = JSON.parse(question['data']) || [];
              listOfImages.push(...question['images']);
            }
          });
          if (response.question.questionType === 1) {
            response.choices.forEach((choice: any, index: number) => {
              const optionValue: any[] = choice.optionValue || [];
              optionValue.forEach((option, optionIndex) => {
                if (option['type'] === 'Images') {
                  option['images'] = JSON.parse(option['data']) || [];
                  listOfImages.push(...option['images']);
                }
              });
              const explanations: any[] = choice.explanation || [];
              explanations.forEach((explanation, explanationIndex) => {
                if (explanation['type'] === 'Images') {
                  explanation['images'] = JSON.parse(explanation['data']) || [];
                  listOfImages.push(...explanation['images']);
                }
              });
            });
          } else if (response.question.questionType === 2) {
            response.answers.explanation.forEach(
              (explanation: any, explanationIndex: number) => {
                if (explanation['type'] === 'Images') {
                  explanation['images'] = JSON.parse(explanation['data']) || [];
                  listOfImages.push(...explanation['images']);
                }
              }
            );
          }
          this.getImages(listOfImages);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  uploadFile(
    event: any,
    fileSelector: any,
    panelIndex: number,
    dataIndex: number,
    questionIndex: number | null
  ) {
    const file = event.target.files[0];
    if (file.size > 1000000) {
      this.notifier.notify('error', 'File size exceeds 1MB.');
      fileSelector.value = '';
    } else if (!file.type.startsWith('image')) {
      this.notifier.notify('error', 'Invalid file format');
      fileSelector.value = '';
    } else {
      const formData = new FormData();
      formData.append('to', 'learningModule');
      formData.append('files', file);
      this.globalApiService.uploadImage(formData).subscribe(
        (response: any) => {
          console.log(response);
          const data = response.data;
          if (data) {
            if (questionIndex !== null) {
              this.editorArray[panelIndex].questions[dataIndex].question[
                questionIndex
              ].images.push(Object.keys(data)[0]);
            } else {
              if (
                this.editorArray[panelIndex].panelType.type === 'quiz' ||
                this.editorArray[panelIndex].panelType.display.includes(
                  'Exercise'
                )
              ) {
                this.editorArray[panelIndex].additionalInfo![
                  dataIndex
                ].images?.push(Object.keys(data)[0]);
              } else {
                this.editorArray[panelIndex].content[dataIndex].images?.push(
                  Object.keys(data)[0]
                );
              }
            }
            this.images = { ...this.images, ...data };
          }
          console.log(this.editorArray, this.images);
          fileSelector.value = '';
        },
        (error: any) => {
          console.log(error);
          this.notifier.notify('error', 'Unable to upload file');
          fileSelector.value = '';
        }
      );
    }
  }

  getImages(listOfImages: string[]) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          this.images = { ...this.images, ...data };
        }
        console.log(this.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  displaySelectAll(flag: boolean) {
    if (this.questions.length === 0) {
      return false;
    } else {
      if (flag) {
        let displaySelectAll = false;
        for (let i = 0; i < this.questions.length; i++) {
          const question = this.questions[i];
          if (!question.selected) {
            displaySelectAll = true;
            break;
          }
        }
        return displaySelectAll;
      } else {
        const selectedQuestions = this.questions.filter((question: any) => {
          return question.selected;
        });
        return selectedQuestions.length === this.questions.length;
      }
    }
  }

  toggleAllQuestions(flag: boolean) {
    this.questions.forEach((question) => {
      question.selected = flag;
    });
  }

  exportToPDF() {
    window.print();
  }

  updateMathjaxValue(event: string, data: MultiData) {
    data.data = event;
  }

  onVideoSelect(event: any, content: MultiData, fileInput: any) {
    console.log('on video selection', event, content, fileInput);
    const files: FileList = event.target.files;
    if (!content) return;

    content.selectedVideos = [];
    for (let i = 0; i < files.length; i++) {
      if (files[i].type.startsWith('video/')) {
        content.selectedVideos.push(files[i]);
      }
    }
    fileInput.value = '';
  }

  uploadVideos(content: any) {
    console.log(structuredClone(content));
    if (!content || !content.selectedVideos || !content.selectedVideos.length) {
      this.notifier.notify('error', 'Please select videos first');
      return;
    }

    if (!this.moduleId) {
      this.notifier.notify('error', 'Please save the module first');
      return;
    }

    const formData = new FormData();
    content.selectedVideos.forEach((file: any) => {
      formData.append('files', file);
    });

    content.isUploading = true;
    content.uploadProgress = 0;

    this.globalApiService
      .uploadLearningModuleVideos(this.moduleId, formData)
      .subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            if (event.total && content.uploadProgress !== undefined) {
              content.uploadProgress = Math.round(
                (100 * event.loaded) / event.total
              );
            }
          } else if (event.type === HttpEventType.Response) {
            console.log('Upload response:', event.body);
            content.isUploading = false;
            const uploadedVideos = event.body?.videos || [];
            if (!content.videos) content.videos = [];

            uploadedVideos.forEach((video: any) => {
              video.safeBunnyUrl = this.sanitizeService.getBunnyVideoUrl(video);
              this.videoMap.set(video.videoId, video);
              content.videos?.push({
                videoId: video.videoId,
                isActive: false,
                isEditorActive: false
              });
            });
            if (uploadedVideos.length > 0) {
              this.notifier.notify('success', 'Videos uploaded successfully');
            }
            content.selectedVideos = [];
            content.uploadProgress = 0;
            console.log('uploaded content', content);
          }
          console.log(
            'editor array after video upload: ',
            structuredClone(this.editorArray)
          );
        },
        (error) => {
          console.error(error);
          this.notifier.notify('error', 'Unable to upload videos');
          content.isUploading = false;
          content.uploadProgress = 0;
        }
      );
  }

  dragAndDropVideo(event: CdkDragDrop<any[] | undefined>, content: any) {
    if (!content || !content.videos) return;

    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(content.videos, event.previousIndex, event.currentIndex);
    }
  }

  toggleVideoStatus(videoId: number, isChecked: boolean) {
    console.log('Toggle fired:', videoId);
    console.log('New value:', isChecked);

    this.globalApiService
      .updateContentVideoStatus(videoId, isChecked)
      .subscribe({
        next: (res) => {
          console.log('API Success:', res);
          if (this.videoMap.has(videoId))
            this.videoMap.get(videoId).isActive = isChecked;
        },
        error: (err) => {
          console.error('API Failed:', err);
        }
      });
  }

  getLearninModuleVideos() {
    this.globalApiService.getLearningModuleVideos(this.moduleId!).subscribe({
      next: (response: any) => {
        console.log(response);
        this.videoMap = new Map<number, any>();
        response.videos.forEach((video: any) => {
          video.safeBunnyUrl = this.sanitizeService.getBunnyVideoUrl(video);
          this.videoMap.set(video.videoId, video);
        });
        console.log('video map', this.videoMap);
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
}
